import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import { AvailableColumns } from '../../../../types/Interfaces';
// import isEqual from 'react-fast-compare';

const useStyles = makeStyles(() => ({
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

interface HeadCell {
  id: string
  numeric: boolean
  label: string
}

const headCells: HeadCell[] = [
  {
    id: 'MAC', numeric: false, label: 'Seriennummer',
  },
  {
    id: 'Motorennummer', numeric: false, label: 'Motorennummer',
  },
  {
    id: 'Betreiber', numeric: false, label: 'Betreiber',
  },
  {
    id: 'Adresse', numeric: false, label: 'Adresse',
  },
  {
    id: 'Auftrag', numeric: false, label: 'Auftrag',
  },
  {
    id: 'Gasart', numeric: false, label: 'Gasart',
  },
  {
    id: 'status', numeric: false, label: 'Status',
  },
  { // NEU
    id: 'Servicevertrag', numeric: false, label: 'Servicevertrag',
  },
  { // NEU
    id: 'ServiceVertragsende', numeric: false, label: 'Ende Servicevertrag',
  },
  { // NEU
    id: 'AnlagenStatus', numeric: false, label: 'Bearbeitungsstatus', // Key, Anzeigename (AnlagenStatus = Bearbeitungsstatus)
  },
  {
    id: 'ServiceGeplant', numeric: false, label: 'Service geplant',
  },
  { // Neu
    id: 'KatWechselGeplant', numeric: false, label: 'Katalysatorwechsel geplant',
  },
  { // NEU
    id: 'WartungGeplant', numeric: false, label: 'Wartung geplant',
  },
  { // Neu
    id: 'letzterService', numeric: false, label: 'Letzter durchgeführter Service',
  },
  { // Neu
    id: 'letzterKatWechsel', numeric: false, label: 'Letzter durchgeführter Katalysatorwechsel',
  },
  { // Label geändert
    id: 'letzteWartung', numeric: false, label: 'Letzte durchgeführte Wartung',
  },
  { // NEU
    id: 'Messtermin', numeric: false, label: 'Messtermin',
  },
  { // NEU
    id: 'Messtermin_Alt', numeric: false, label: 'Messtermin alt',
  },
  {// NEU
    id: 'ausfalltagePercent_Log', numeric: false, label: 'Ausfalltage (Jahr/% - Klassierung)',
  },
  {// NEU
    id: 'ausfallstundenPercent', numeric: false, label: 'Ausfallstunden (Jahr/% - Klassierung)',
  },
  // { // NEU - Erstmal nicht
  //   id: 'DaysWithoutData', numeric: false, label: 'Tage ohne Daten (60)',
  // },
  // { // NEU - Noch nicht übernommen (gleich wie versionsNr?)
  //   id: 'SoftwareVersion', numeric: false, label: 'Software Version',
  // },
  // { // War Auskommentiert
  //   id: 'nox', numeric: true, label: 'Live NOₓ*', // Nicht in Tabelle
  // },
  // { // War Auskommentiert
  //   id: 'temp', numeric: true, label: 'Temperatur', // Nicht in Tabelle
  // },
  {
    id: 'Messbericht_bis', numeric: false, label: 'Messbericht',
  },
  {
    id: 'versionsNr', numeric: false, label: 'Versionsnr.',
  },
  {
    id: 'versionsDatum', numeric: false, label: 'Versionsdatum',
  },
  {
    id: 'betriebsstunden', numeric: true, label: 'Betriebsstd.',
  },
  {
    id: 'ausfallstunden', numeric: true, label: 'Ausfallstd.',
  },
  {
    id: 'co_m_sort', numeric: true, label: 'HMW CO*',
  },
  {
    id: 'nox_m_sort', numeric: true, label: 'HMW NOₓ*',
  },
];

interface DashboardTableHeadProps {
  onRequestSort: Function
  order: 'asc' | 'desc'
  orderBy: string
  columns: AvailableColumns
}

function DashboardTableHead({
  onRequestSort, order, orderBy, columns,
}: DashboardTableHeadProps) {
  const classes = useStyles();

  const createSortHandler = (property: string) => (event: any) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {headCells.map((headCell) => (
          // (columns[headCell.id] || headCell.id === 'MAC' || headCell.id === 'status') ? ( // Muss noch raus
          (columns[headCell.id] || headCell.id === 'MAC') ? (
            <TableCell
              key={headCell.id}
              align={headCell.numeric ? 'right' : 'left'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={order}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}
                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ) : (
            null
          )
        ))}
      </TableRow>
    </TableHead>
  );
}

// export default React.memo(DashboardTableHead, isEqual);
export default (DashboardTableHead);
